import { CommonModule } from '@angular/common';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StateModule } from '@spartacus/core';
import { AlertsStatePersistenceService } from '../services/alerts-state-persistence.service';
import { ALERTS_FEATURE } from './alerts-state';
import { effects } from './effects/index';
import { reducerProvider, reducerToken } from './reducers/index';

export function alertsStatePersistenceFactory(alertsStatePersistenceService: AlertsStatePersistenceService): () => void {
  const result = () => alertsStatePersistenceService.initSync();
  return result;
}

@NgModule({
  imports: [CommonModule, StateModule, StoreModule.forFeature(ALERTS_FEATURE, reducerToken), EffectsModule.forFeature(effects)],
  providers: [
    reducerProvider,
    provideAppInitializer(() => {
      const initializerFn = alertsStatePersistenceFactory(inject(AlertsStatePersistenceService));
      return initializerFn();
    }),
  ],
})
export class AlertsStoreModule {}
